import { Link, useLocation } from "react-router-dom";
import { HOME_PATH, HOME_SEARCH_PATH } from "../utility/path";
import { useSelector } from "react-redux";
import "../NoDataFound.css";

const NoDataFound = ({ loading, selectedCategory }) => {
  const location = useLocation();
  const categoriesData = useSelector(state => state?.categories?.data);
  const categoryName = categoriesData.map((n) => (n?._id == selectedCategory) ? n.name : "");

  // Determine the appropriate path dynamically
  const backToPath = location?.pathname === HOME_PATH ? HOME_SEARCH_PATH : HOME_PATH;

  return (
    <div>
      {loading && "Loading..."}
      {!loading && selectedCategory &&
        <div className="ndf-wrapper">
          <div className="ndf-card">
            {/* Icon */}
            <div className="ndf-icon">🔍</div>

            {/* Text */}
            <p className="ndf-title">No professionals found</p>
            <p className="ndf-subtitle">
              No one listed under <strong className="ndf-highlight capitalize">{categoryName}</strong> nearby.
            </p>

            {/* Suggestions */}
            <div className="ndf-suggestions">
              {/* <div className="ndf-suggestion">
                <i className="fa fa-map-marker ndf-suggestion__icon" />
                <span>Try a nearby area or pin code</span>
              </div> */}
              <div className="ndf-suggestion">
                <i className="fa fa-th-large ndf-suggestion__icon" />
                <span>Browse a similar category</span>
              </div>
            </div>

            {/* CTA */}
            <Link to={backToPath}>
              <button className="ndf-btn">
                Go back to categories
              </button>
            </Link>
          </div>
        </div>
      }
    </div>
  );
};

export default NoDataFound;
